<template>
  <div id="block_list_actions" class="px-2 py-3 w-full">
    <div v-if="!removeLoading">
      <a-button
        @click="handleRemove"
        class="secondary_medium"
        :loading="removeLoading"
      >
        <span class="text-white">Remove from list</span>
      </a-button>
    </div>
    <div v-else>
      <CustomLoader :size="16" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { message } from "ant-design-vue";
import CustomLoader from "@/src/components/CustomLoader.vue";
import DashboardService from "../../api/DashboardService.js";

const props = defineProps({
  row: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(["refresh"]);
const removeLoading = ref(false);

const handleRemove = async () => {
  removeLoading.value = true;
  try {
    console.log("Remove from block list:", props.row);
    const response = await DashboardService.deleteEmailAndDomainBlocklist(
      props.row.id,
      props.row.type,
    );
    if (response?.status === 200 || response?.success) {
      message.success("Removed from block list successfully");
      emit("refresh");
    } else {
      message.error("Failed to remove from block list");
    }
  } catch (error) {
    console.error("Error while removing from block list:", error);
  } finally {
    removeLoading.value = false;
  }
};
</script>

<style scoped>
/* Override ant-design button styles to match the design */
:deep(.ant-btn) {
  background-color: #1f1f1f !important;
  border: none !important;
  box-shadow: none !important;
  height: auto !important;
  padding: 8px 16px !important;
}

:deep(.ant-btn:hover) {
  background-color: #2a2a2a !important;
}

:deep(.ant-btn-loading) {
  opacity: 0.7;
}
</style>
